
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tableplace",
      function () {
        return require("private-next-pages/tableplace.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tableplace"])
      });
    }
  